import { z } from 'zod';
import { DeliverableKindSchema } from '../enums.js';
import { IdSchema, IsoDateTimeSchema } from './common.js';
/** projects/{id}/deliverables/{id} */
export const DeliverableSchema = z.object({
    id: IdSchema,
    kind: DeliverableKindSchema,
    label: z.string().min(1).max(200),
    description: z.string().max(1000).optional(),
    url: z.string().url().optional(),
    storagePath: z.string().optional(),
    mimeType: z.string().optional(),
    /** kind 'slides' only: the training session whose deck this is. The deck lives in Pulse, so
     * this replaces `url` — the web app links to the session's slides from it. */
    trainingSessionId: IdSchema.optional(),
    createdByUid: IdSchema,
    createdAt: IsoDateTimeSchema,
});
export const CreateDeliverableInputSchema = z.object({
    kind: DeliverableKindSchema,
    label: z.string().min(1).max(200),
    description: z.string().max(1000).optional(),
    url: z.string().url().optional(),
    storagePath: z.string().optional(),
    mimeType: z.string().optional(),
});
//# sourceMappingURL=deliverable.js.map